import { type ReportAccessGrant } from '@webapp/platform/iam/entities/ReportAccessGrant'
import { useReportAccessGrantListPresenter } from './useReportAccessGrantListPresenter'
import { ReportAccessGrantListView } from '../../views/ReportAccessGrantListView'

export interface IReportAccessGrantListPresenterProps {
  secondaryCategoryId: number
  highlightedGrantId: number | undefined
  /** A grant or revoke is in flight; Clear all would race it */
  isGrantCommandPending: boolean
  /** `isLastGrant`: no tag is left to take focus once it is removed */
  onRemoveGrant: (
    grant: ReportAccessGrant,
    options: { isLastGrant: boolean }
  ) => void
  onClearAll: (grants: ReportAccessGrant[]) => void
  /** "Try again" unmounts with the error; focus has to land elsewhere */
  onRetry: () => void
}

export const ReportAccessGrantListPresenter = ({
  secondaryCategoryId,
  highlightedGrantId,
  isGrantCommandPending,
  onRemoveGrant,
  onClearAll,
  onRetry,
}: IReportAccessGrantListPresenterProps) => {
  const {
    data: { grantTags, clearAllCount },
    states: {
      showInitialLoader,
      showErrorState,
      showEmptyState,
      showClearAll,
      isClearAllDisabled,
    },
    methods: {
      onRemoveGrant: handleRemoveGrant,
      onClearAll: handleClearAll,
      onRetry: handleRetry,
    },
  } = useReportAccessGrantListPresenter({
    secondaryCategoryId,
    highlightedGrantId,
    isGrantCommandPending,
    onRemoveGrant,
    onClearAll,
    onRetry,
  })

  return (
    <ReportAccessGrantListView
      grantTags={grantTags}
      clearAllCount={clearAllCount}
      showInitialLoader={showInitialLoader}
      showErrorState={showErrorState}
      showEmptyState={showEmptyState}
      showClearAll={showClearAll}
      isClearAllDisabled={isClearAllDisabled}
      onRemoveGrant={handleRemoveGrant}
      onClearAll={handleClearAll}
      onRetry={handleRetry}
    />
  )
}

ReportAccessGrantListPresenter.displayName = 'ReportAccessGrantListPresenter'
